import { render, staticRenderFns } from "./ForumPostView.vue?vue&type=template&id=37fbe930&scoped=true&"
import script from "./ForumPostView.vue?vue&type=script&lang=js&"
export * from "./ForumPostView.vue?vue&type=script&lang=js&"
import style0 from "./ForumPostView.vue?vue&type=style&index=0&id=37fbe930&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fbe930",
  null
  
)

export default component.exports